import { useCallback, useEffect, useState } from 'react';
import './styles.scss';
import PageLoader from '../../../../../../components/other/PageLoader';
import { getScheduledTasksService } from '../../../../../../services/cna/scheduled-tasks';
import { isResponseOk } from '../../../../../../utility/isResponseOk';
import ScheduledTaskRow from './components/ScheduledTaskRow';
import Select from 'react-select';
import ReactPaginate from 'react-paginate';

const initialFilters = {
  search: '',
  shift: { label: 'All', value: 'all' },
};

const ScheduledTasksTabPanel = ({ assignmentId, handleGetAssignment }) => {
  const [isLoadingTasks, setIsLoadingTasks] = useState(false);
  const [page, setPage] = useState(0);
  const [tasks, setTasks] = useState([]);
  const [tasksPaginationData, setTasksPaginationData] = useState({});
  const [filters, setFilters] = useState(initialFilters);

  const getScheduledTasks = useCallback(async () => {
    try {
      const params = {
        search: filters.search,
        shift: filters.shift.value,
        page: page + 1,
      };
      const response = await getScheduledTasksService(assignmentId, params);
      if (isResponseOk(response)) {
        if (response.data?.results) {
          setTasks(response.data?.results);
          setTasksPaginationData({
            count: response.data?.count,
            next: response.data?.next,
            page: response.data?.page,
            previous: response.data?.previous,
            total_pages: response.data?.total_pages,
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, [assignmentId, filters.search, filters.shift.value, page]);

  useEffect(() => {
    getScheduledTasks();
  }, [getScheduledTasks]);

  const handleChangeFilter = (key, value) => {
    setFilters((state) => ({ ...state, [key]: value }));
  };

  return (
    <div>
      <div className="library-filters scheduled-tasks-filters">
        <div className="library-filters-wrapper" style={{ alignItems: 'flex-end' }}>
          <div className="form-item">
            <label className="form-label">Shift</label>
            <Select
              value={filters.shift}
              className="form-control-select"
              classNamePrefix="react-select"
              options={[
                { label: 'All', value: 'all' },
                { label: '11-7', value: '11_7' },
                { label: '7-3', value: '7_3' },
                { label: '3-11', value: '3_11' },
              ]}
              onChange={(e) => handleChangeFilter('shift', e)}
            />
          </div>
          <div className="library-filter-search form-control-item">
            <input
              type="text"
              className="form-control"
              value={filters.search}
              onChange={(e) => handleChangeFilter('search', e.target.value)}
              placeholder="Search"
            />
            <i className="icon-search"></i>
          </div>
          <button className="btn btn-outline clear-all-btn" onClick={() => setFilters(initialFilters)}>
            Clear All
          </button>
        </div>
      </div>

      {tasks.length ? (
        <div className="table-responsive table-default table-full scheduled-tasks-table">
          <div className="table-container">
            <table className="scheduled-tasks-table">
              <thead>
                <tr>
                  <th className="resident-header-col">Resident</th>
                  <th className="bed-header-col">Bed</th>
                  <th className="tasks-header-col">Tasks</th>
                  <th className="shifts-header-col">Shifts</th>
                  <th className="pediod-header-col">Period</th>
                  <th className="action-header-col"></th>
                </tr>
              </thead>
              <tbody>
                {isLoadingTasks && <PageLoader />}
                {tasks.map((item, index) => (
                  <ScheduledTaskRow
                    key={index}
                    item={item}
                    assignmentId={assignmentId}
                    getScheduledTasks={getScheduledTasks}
                    handleGetAssignment={handleGetAssignment}
                  />
                ))}
              </tbody>
            </table>

            {tasksPaginationData.count > 8 && (
              <ReactPaginate
                className="react-pagination"
                breakLabel="..."
                nextLabel="Next ->"
                pageRangeDisplayed={5}
                pageCount={tasksPaginationData.total_pages}
                forcePage={page}
                previousLabel="<- Previous"
                onPageChange={(page) => setPage(page.selected)}
                containerClassName="pagination"
                activeClassName="active"
              />
            )}
          </div>
        </div>
      ) : (
        <div className="empty-page">
          <h3 className="empty-page-title">There are no scheduled tasks</h3>
        </div>
      )}
    </div>
  );
};

export default ScheduledTasksTabPanel;
